import { controls, grouped } from "../../controls";

const bankapexpendency = {
  label: "Quarterly Pendency",
  starting: true,
  url: "apexpendency",
  pageLabel: "Quarterly Pendency",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "lqe" }),

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Quarterly Pendency",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Report Name",
        accessor: "report_display",
        rwidth: "*"
      },
      {
        Header: "Status",
        accessor: "status",
        type: "tick"
      },
      {
        Header: "Upload Date",
        accessor: "upload_date",
        type: "date"

      },
      {
        Header: "Apex Remark",
        accessor: "apex_remark"
      },
      {
        Header: "Deadline",
        accessor: "deadline",
        type: "date"
      }
    ]
  }
};

export default bankapexpendency;